import Code from "../../../components/code";
import DocsAuthor from "../../components/docsAuthor";
export const diagnosticsPage = {
  title: "Diagnostics",
  sections: [
    { id: "ciInstall", name: "Clean Install (ci)" },
    { id: "verifyInstall", name: "Verify Install" },
    { id: "whyInstalled", name: "Why Installed" },
  ],
  content: (
    <>
      <DocsAuthor nickname="StrayVibes" publishedAt="August 22, 2026 at 12:00 PM" />
      <section id="ciInstall">
        <h2>🔒 Clean Install - Reproducible Every Time!</h2>
        <p>
          Need a bulletproof, reproducible install? 🔒 Run{" "}
          <Code fullWidth>meow ci</Code> to install exact versions straight
          from your committed <Code>deps.neko</Code> lock file. If your{" "}
          <Code>package.json</Code> and lock file are out of sync, Neko-CLI
          stops and tells you exactly what to fix, no surprises! 🐾
        </p>
      </section>
      <section id="verifyInstall">
        <h2>🔍 Verify Install - Trust, But Verify!</h2>
        <p>
          Wondering if your <Code>node_modules</Code> really matches what's
          locked? 🧐 Use <Code fullWidth>meow verify</Code> to check every
          package against <Code>deps.neko</Code> and get a clear summary of
          what's ok, mismatched, or missing.
        </p>
      </section>
      <section id="whyInstalled">
        <h2>❓ Why Installed - Trace the Chain!</h2>
        <p>
          Ever wonder why a package snuck into your project? 🕵️ Run{" "}
          <Code fullWidth>meow why &lt;pkg&gt;</Code> to see the full
          dependency chain explaining exactly why it's installed.
        </p>
      </section>
    </>
  ),
};
